import React, {Component} from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';

/**
 * Condition Score Slider component
 */
class ConditionScoreSlider extends Component {
  componentDidUpdate() {
    setTimeout(() => {
      const sliderHandle = document.querySelectorAll('.rc-slider-handle');
      const handleName = window.Drupal?.t
      ? window.Drupal.t("Slider Handle")
      : `Slider Handle`;
      if (sliderHandle) {
        sliderHandle.forEach(handle => {
          handle.setAttribute('aria-label', handleName);
        })
      }
    }, 0);
  }

  render() {
    const {data, greyed, selected, onSelect, selectedCriticalCare, casuistic} = this.props;

    return (
      <div className="nppe2-fc-weeks-litter-slider nppe2-fc-slider">
        <div className="nppe2-fc-sub-title">
          {data.label}
        </div>
        <div className="row">
          <div className="col-xs-6 nppe2-fc-slider__text" disabled={greyed}>
          </div>
          <div className="col-xs-6 text-right nppe2-fc-slider__text--red" disabled={greyed}>
          {selected} / 9
          </div>
        </div>
        <Slider
          name="nppe2-fc-condition-score-slider"
          value={selected}
          min={1}
          max={9}
          step={1}
          onChange={(id) => onSelect(id)}
          disabled = {(selectedCriticalCare ||
            casuistic == "pregnancy" ||
            casuistic == "lactation" ||
            casuistic == "growth") ? "disabled" : ""}
          />

      </div>
    );
  }
}

export default ConditionScoreSlider;
